module.exports = __webpack_public_path__ + "static/media/Icon_E16441.54033ec1.png";